import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Leaf, Coffee, ShoppingCart, FileText, Gift, Lock, Zap, Shield } from 'lucide-react';
export function OfferStack() {
  return <section className="px-6 py-5 max-w-4xl mx-auto" data-id="element-281">
      <FadeIn data-id="element-282">
        <div className="bg-[#4A5D3A] rounded-3xl p-1 md:p-2 shadow-2xl" data-id="element-283">
          <div className="bg-[#FAF6F0] rounded-[22px] p-6 md:p-12" data-id="element-284">
            <p className="text-sm md:text-base italic text-[#9B4F2B] mb-6 font-medium tracking-wide" data-id="element-285">
              Hoy no recibes solo un ebook. Recibes el protocolo completo para
              aplicar el método en casa.
            </p>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#4A5D3A] mb-8" data-id="element-286">
              TODO LO QUE RECIBES HOY
            </h2>

            {/* Offer Table */}
            <div className="mb-10" data-id="element-287">
              <table className="w-full" data-id="element-288">
                <thead data-id="element-289">
                  <tr className="border-b-2 border-[#4A5D3A]/20" data-id="element-290">
                    <th className="text-left py-3 px-2 text-[#2D2A26] font-bold" data-id="element-291">
                      Lo que recibes
                    </th>
                    <th className="text-right py-3 px-2 text-[#2D2A26] font-bold" data-id="element-292">
                      Valor real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-293">
                  {/* Main Products */}
                  <tr className="border-b border-[#4A5D3A]/10" data-id="element-294">
                    <td className="py-4 px-2" data-id="element-295">
                      <div className="flex items-center gap-3" data-id="element-296">
                        <Leaf className="text-[#4A5D3A] flex-shrink-0" size={20} data-id="element-297" />
                        <span className="text-[#2D2A26]" data-id="element-298">
                          Guía Maestra S.O.S
                          <br data-id="element-299" />
                          (Protocolo completo)
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right text-[#2D2A26] font-medium" data-id="element-300">
                      $37 USD
                    </td>
                  </tr>
                  <tr className="border-b border-[#4A5D3A]/10" data-id="element-301">
                    <td className="py-4 px-2" data-id="element-302">
                      <div className="flex items-center gap-3" data-id="element-303">
                        <Coffee className="text-[#4A5D3A] flex-shrink-0" size={20} data-id="element-304" />
                        <span className="text-[#2D2A26]" data-id="element-305">
                          Recetario de 7 Elixires Calmantes
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right text-[#2D2A26] font-medium" data-id="element-306">
                      $27 USD
                    </td>
                  </tr>
                  <tr className="border-b border-[#4A5D3A]/10" data-id="element-307">
                    <td className="py-4 px-2" data-id="element-308">
                      <div className="flex items-center gap-3" data-id="element-309">
                        <ShoppingCart className="text-[#4A5D3A] flex-shrink-0" size={20} data-id="element-310" />
                        <span className="text-[#2D2A26]" data-id="element-311">
                          Checklist del Botiquín Calmante
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right text-[#2D2A26] font-medium" data-id="element-312">
                      $17 USD
                    </td>
                  </tr>
                  <tr className="border-b border-[#4A5D3A]/10" data-id="element-313">
                    <td className="py-4 px-2" data-id="element-314">
                      <div className="flex items-center gap-3" data-id="element-315">
                        <FileText className="text-[#4A5D3A] flex-shrink-0" size={20} data-id="element-316" />
                        <span className="text-[#2D2A26]" data-id="element-317">
                          Hoja de Vaciado Mental
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right text-[#2D2A26] font-medium" data-id="element-318">
                      $17 USD
                    </td>
                  </tr>

                  {/* Bonuses */}
                  <tr className="border-b border-[#C4A265]/30 bg-[#C4A265]/10" data-id="element-319">
                    <td className="py-4 px-2" data-id="element-320">
                      <div className="flex items-center gap-3" data-id="element-321">
                        <Gift className="text-[#C4A265] flex-shrink-0" size={20} data-id="element-322" />
                        <div data-id="element-323">
                          <span className="text-xs font-bold text-[#9B4F2B] uppercase tracking-wider block" data-id="element-324">
                            BONO 1
                          </span>
                          <span className="text-[#2D2A26]" data-id="element-325">
                            La Receta Exacta S.O.S.
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right" data-id="element-326">
                      <span className="text-[#2D2A26]/50 line-through text-sm mr-2" data-id="element-327">
                        $27 USD
                      </span>
                      <span className="text-[#4A5D3A] font-bold" data-id="element-328">GRATIS</span>
                    </td>
                  </tr>
                  <tr className="border-b border-[#C4A265]/30 bg-[#C4A265]/10" data-id="element-329">
                    <td className="py-4 px-2" data-id="element-330">
                      <div className="flex items-center gap-3" data-id="element-331">
                        <Gift className="text-[#C4A265] flex-shrink-0" size={20} data-id="element-332" />
                        <div data-id="element-333">
                          <span className="text-xs font-bold text-[#9B4F2B] uppercase tracking-wider block" data-id="element-334">
                            BONO 2
                          </span>
                          <span className="text-[#2D2A26]" data-id="element-335">
                            Mapa de Calma Nocturna
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right" data-id="element-336">
                      <span className="text-[#2D2A26]/50 line-through text-sm mr-2" data-id="element-337">
                        $27 USD
                      </span>
                      <span className="text-[#4A5D3A] font-bold" data-id="element-338">GRATIS</span>
                    </td>
                  </tr>
                  <tr className="border-b border-[#C4A265]/30 bg-[#C4A265]/10" data-id="element-339">
                    <td className="py-4 px-2" data-id="element-340">
                      <div className="flex items-center gap-3" data-id="element-341">
                        <Gift className="text-[#C4A265] flex-shrink-0" size={20} data-id="element-342" />
                        <div data-id="element-343">
                          <span className="text-xs font-bold text-[#9B4F2B] uppercase tracking-wider block" data-id="element-344">
                            BONO 3
                          </span>
                          <span className="text-[#2D2A26]" data-id="element-345">
                            Botiquín de Emergencia 2:00 AM
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-2 text-right" data-id="element-346">
                      <span className="text-[#2D2A26]/50 line-through text-sm mr-2" data-id="element-347">
                        $27 USD
                      </span>
                      <span className="text-[#4A5D3A] font-bold" data-id="element-348">GRATIS</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Pricing Summary */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#4A5D3A] max-w-md mx-auto text-center relative overflow-hidden" data-id="element-349">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#4A5D3A]" data-id="element-350"></div>
            <p className="italic text-[#2D2A26]/80 text-sm md:text-base bg-[#FAF6F0] p-4 rounded-lg" data-id="element-351">
                "Si compraras cada guía por separado
pagarías aproximadamente:"
              </p>
              <div className="space-y-4 mb-6" data-id="element-352">
                <div className="flex justify-between items-center text-lg" data-id="element-353">
                
                  <span className="text-[#2D2A26] font-medium" data-id="element-354">
                    VALOR TOTAL
                  </span>
                  <span className="text-[#FF0000] line-through font-bold text-2xl" data-id="element-355">
                    $179 USD
                  </span>
                </div>
                <div className="flex justify-between items-center text-lg border-t border-gray-100 pt-4" data-id="element-356">
                  <span className="text-[#4A5D3A] font-bold" data-id="element-357">VALOR</span>
                  <span className="text-[#4A5D3A] font-bold text-3xl" data-id="element-358">
                    $6.39 USD
                  </span>
                </div>
              </div>

              <p className="italic text-[#2D2A26]/80 text-sm md:text-base bg-[#FAF6F0] p-4 rounded-lg" data-id="element-359">
                "Menos que un café con leche. Pero con todo lo que necesitas
                para que esta noche sea diferente."
              </p>
            </div>

            {/* CTA */}
            <div className="text-center mt-10" data-id="element-360">
              <CTAButton className="py-6 text-lg md:text-xl" data-id="element-361">
                SÍ — QUIERO EL PROTOCOLO COMPLETO + LOS 3 BONOS → $6.39 USD
              </CTAButton>

              <div className="flex items-center justify-center gap-4 mt-6 text-sm text-[#2D2A26]/60 flex-wrap" data-id="element-362">
                <div className="flex items-center gap-1" data-id="element-363">
                  <Lock size={16} className="text-[#4A5D3A]" data-id="element-364" />
                  <span data-id="element-365">Pago Seguro</span>
                </div>
                <span className="hidden sm:inline" data-id="element-366">·</span>
                <div className="flex items-center gap-1" data-id="element-367">
                  <Zap size={16} className="text-[#C4A265]" data-id="element-368" />
                  <span data-id="element-369">Acceso Inmediato</span>
                </div>
                <span className="hidden sm:inline" data-id="element-370">·</span>
                <div className="flex items-center gap-1" data-id="element-371">
                  <Leaf size={16} className="text-[#4A5D3A]" data-id="element-372" />
                  <span data-id="element-373">Garantía 7 días</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}